import {createClient} from 'next-sanity';

export const projectId = 'u4y7d6w6';
export const dataset = 'production'; // "production"
export const apiVersion = '2023-03-25';
export const previewToken = process.env.NEXT_PUBLIC_SANITY_PREVIEW_TOKEN;

export default createClient({
  projectId: projectId,
  dataset: dataset,
  useCdn: true, // `false` if you want to ensure fresh data
  apiVersion: apiVersion,
});
